// extracted by mini-css-extract-plugin
export default {"title":"DeniedUserModal_title__1ukDA"};